import { useRouteContext } from '@tanstack/react-router';
import { ngoAreaUrl } from './request-host';

/**
 * Builds absolute links into the NGO area from anywhere on the marketing site.
 *
 * A hook rather than a constant because the target host is derived from the request's own host —
 * see `ngoAreaUrl` — so it differs per environment and is only known from the router context.
 *
 * Pass the PUBLIC path (`/login`, `/onboarding`), not the route-file path (`/ngos/login`).
 */
export function useNgoAreaUrl(): (path: string) => string {
	const { baseUrl } = useRouteContext({ from: '__root__' });
	return (path: string) => ngoAreaUrl(baseUrl, path);
}
